import { FC } from 'react'
import cn from 'classnames'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import type { CrmLeadTaskCounts } from '@/api/types/crm/crmLeadTasks.types'
import { normalizeCrmLeadTaskCounts } from '../../utils/crmLeadTaskCounts'
import classes from './index.module.css'

type CrmLeadTaskCountsBadgesProps = {
  taskCounts?: CrmLeadTaskCounts | null
  className?: string
  /** Компактнее — для карточки канбана. */
  size?: 'default' | 'compact'
}

const formatCount = (n: number) => (n > 99 ? '99+' : String(n))

/** Бейджи overdue / today из `task_counts` (таблица, канбан, таб карточки). */
const CrmLeadTaskCountsBadges: FC<CrmLeadTaskCountsBadgesProps> = ({
  taskCounts,
  className,
  size = 'default',
}) => {
  const { today, overdue } = normalizeCrmLeadTaskCounts(taskCounts)
  if (today <= 0 && overdue <= 0) return null

  return (
    <span
      className={cn(
        classes.badges,
        size === 'compact' && classes.badgesCompact,
        className,
      )}
    >
      {overdue > 0 ? (
        <TooltipWrapper title="Кол-во просроченных задач" placement="top">
          <span
            className={cn(classes.badge, classes.badgeOverdue)}
            aria-label={`Просроченных задач: ${overdue}`}
          >
            {formatCount(overdue)}
          </span>
        </TooltipWrapper>
      ) : null}
      {today > 0 ? (
        <TooltipWrapper title="кол-во задач на сегодня" placement="top">
          <span
            className={cn(classes.badge, classes.badgeToday)}
            aria-label={`Задач на сегодня: ${today}`}
          >
            {formatCount(today)}
          </span>
        </TooltipWrapper>
      ) : null}
    </span>
  )
}

export default CrmLeadTaskCountsBadges
